<template>
  <div class="input">
    <label :class="{ isRequired: required, isDisabled: disabled }">
      <input
        type="radio"
        :name="inputName"
        :id="inputId"
        @focus="isFocused = true"
        @blur="isFocused = false"
        @change="$emit('update:modelValue', $event.target.value); $emit('change', $event.target.value)"
        :checked="modelValue === value"
        :required="required"
        :disabled="disabled"
        :value="value"
      />
      <span class="mimicry"></span>
      <span class="text" v-if="label">{{ label }}</span>
    </label>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    label: {
      type: String,
    },
    name: {
      type: String,
    },
    id: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      isFocused: false,
      inputId: "",
      inputName: "",
    };
  },
  created() {
    this.inputId =
      this.id ||
      "id" + window.crypto.getRandomValues(new Uint32Array(1)).toString();
    this.inputName = this.name || this.inputId;
  },
});
</script>

<style lang="scss" scoped>
.input {
  position: relative;
  color: $color-primary-gray;
}

label {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;

  &:not(.isDisabled):hover {
    .mimicry {
      border-color: $color-primary-blue;
      background-color: $color-secondary-brightblue;
    }
  }

  &.isRequired {
    &::after {
      content: "";
      display: block;
      position: absolute;
      right: 10px;
      top: 10px;
      width: 6px;
      height: 6px;
      border-radius: 6px;
      background-color: #000;
      pointer-events: none;
    }
  }

  &.isDisabled {
    cursor: not-allowed;
    color: $color-secondary-bluegray-50;
    .mimicry {
      border-color: $color-secondary-bluegray-50;
    }
  }
}

input[type="radio"] {
  display: none;

  &:checked {
    & + .mimicry {
      border-color: $color-primary-blue;
      &::before {
        transform: scale(1);
      }
    }
  }
}

.mimicry {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  width: 20px;
  height: 20px;
  position: relative;
  border: 2px solid $color-primary-gray;
  border-radius: 10px;
  transition: all 0.3s ease;

  &::before {
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 5px;
    display: block;
    background-color: $color-primary-blue;
    transform: scale(0);
    transition: transform 0.2s ease;
  }
}

.text {
  margin-left: 12px;
}
</style>
